// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import {application} from "./application"
import AdminNotificationsController from "./admin_notifications_controller"
application.register("admin-notifications", AdminNotificationsController)
import AdminPaypalPayoutsController from "./admin_paypal_payouts_controller"
application.register("admin-paypal-payouts", AdminPaypalPayoutsController)
import AdminAccountingController from "./admin_accounting_controller"
application.register("admin-accounting", AdminAccountingController)

import AdminRefundsController from "./admin_refunds_controller"
application.register("admin-refunds", AdminRefundsController)
import AdminParentRefundController from "./admin_parent_refund_controller"
application.register("admin-parent-refund", AdminParentRefundController)

import AdminCharityInsightsController from "./admin_charity_insights_controller"
application.register("admin-charity-insights", AdminCharityInsightsController)
import AdminCharityLogoController from "./admin_charity_logo_controller"
application.register("admin-charity-logo", AdminCharityLogoController)

import AdminCharityPasswordResetController from "./admin_charity_password_reset_controller"
application.register("admin-charity-password-reset", AdminCharityPasswordResetController)

import AdminTaxReceiptsController from "./admin_tax_receipts_controller"
application.register("admin-tax-receipts", AdminTaxReceiptsController)

import HeroAnimationsController from "./hero_animations_controller"

application.register("hero-animations", HeroAnimationsController)

import CardAnimationsController from "./card_animations_controller"

application.register("card-animations", CardAnimationsController)

import HowItWorksAnimationsController from "./how_it_works_animations_controller"

application.register("how-it-works-animations", HowItWorksAnimationsController)

import ChoicesController from "./choices_controller"

application.register("choices", ChoicesController)

import ContactController from "./contact_controller"

application.register("contact", ContactController)

import FaqController from "./faq_controller"

application.register("faq", FaqController)

import HelloController from "./hello_controller"

application.register("hello", HelloController)

import SwiperController from "./swiper_controller"

application.register("swiper", SwiperController)

import ShareFormController from "./share_form_controller"

application.register("share-form", ShareFormController)

import GalleryController from "./gallery_controller"

application.register("gallery", GalleryController)

import LoginController from "./login_controller"

application.register("login", LoginController)

import AuthToggleController from "./auth_toggle_controller"

application.register("auth-toggle", AuthToggleController)

import SignupController from "./signup_controller"

application.register("signup", SignupController)

import EditorController from "./editor_controller"

application.register("editor", EditorController)

import CharityFromController from "./charity_form_controller"

application.register("charity-form-validation", CharityFromController)

import DatePickerController from "./datepicker_controller"

application.register("datepicker", DatePickerController)

import BirthdayDatepickerController from "./birthday_datepicker_controller"

application.register("birthday-datepicker", BirthdayDatepickerController)

import ReminderController from "./reminder_controller"

application.register("reminder", ReminderController)

import PopupReminderController from "./popup_reminder_controller"

application.register("reminder-popup", PopupReminderController)

import AccountLocationFormController from "./account_location_form_controller"

application.register("account-location", AccountLocationFormController)

import ProfileValidationFormController from "./profile_validation_controller"

application.register("profile-validation", ProfileValidationFormController)

import AddGuestValidationFormController from "./add_guest_form_controller"

application.register("add-guest-validation", AddGuestValidationFormController)

import CollapseController from "./collapse_controller"

application.register("collapse", CollapseController)

import CardSelectorController from "./card_selector_controller"

application.register("card-selector", CardSelectorController)

import InvitationFilterController from "./invitation_filter_controller"

application.register("invitation-filters", InvitationFilterController)

import StepSwiperController from "./steps_swiper_controller"

application.register("steps", StepSwiperController)

import CharityFilterController from "./charity_filter_controller"

application.register("charity-filter", CharityFilterController)

import CharityDirectoryFiltersController from "./charity_directory_filters_controller"

application.register("charity-directory-filters", CharityDirectoryFiltersController)

import SidebarController from "./sidebar_controller"

application.register("sidebar", SidebarController)

import ClickHandlerController from "./click_handler_controller"

application.register("click-handler", ClickHandlerController)

import InvitationAddGuestController from "./inviation_add_guest_controller"

application.register("invitation-add-guest-form", InvitationAddGuestController)

import EditorColorPickerController from "./color_picker_controller"

application.register("editor-color-picker", EditorColorPickerController)

import FontSizeController from "./font_size_controller"

application.register("font-size", FontSizeController)

import InvitationFormController from "./invitation_form_controller"

application.register("invitation-form", InvitationFormController)

import FlatPickerController from "./flatpicker_controller.js"

application.register("flat-picker", FlatPickerController)

import TextCaseController from "./text_case_controller.js"

application.register("text-case", TextCaseController)

import EditorChoiceController from "./editor_choice_controller.js"

application.register("editor-choices", EditorChoiceController)

import ImageDragAreaController from "./image_drag_area_controller.js"

application.register("image-drop-area", ImageDragAreaController)

import MobileToolPickerController from "./mobile_tool_picker_controller.js"

application.register("box-selector", MobileToolPickerController)

import PanelManagerController from "./panel_manager_controller.js"

application.register("panel-manager", PanelManagerController)

import AirDatePickerController from "./air_datepicker_controller.js"

application.register("air-datepicker", AirDatePickerController)

import CopyContactController from "./copy_contact_controller.js"

application.register("copy-contact", CopyContactController)

import FormLoaderController from "./form_loader_controller.js"

application.register("form-loader", FormLoaderController)

import FindPartyValidationController from "./find_party_validation_controller.js"

application.register("find-party-validation", FindPartyValidationController)

import ScrollToTopController from "./scroll_to_top_controller.js"

application.register("scroll-to-top", ScrollToTopController)

import RevealController from "./reveal_controller.js"

application.register("reveal", RevealController)

import NavbarController from "./navbar_controller.js"

application.register("navbar_controller", NavbarController)

import ClipboardController from "./clipboard_controller.js"

application.register("clipboard", ClipboardController)

import LocalSearchController from "./local_search_controller.js"

application.register("local-search", LocalSearchController)

import PasswordToggleController from "./password_toggle_controller.js"

application.register("password-toggle", PasswordToggleController)

import FormDirtyController from "./form_dirty_controller.js"

application.register("form-dirty", FormDirtyController)

import FlashHighlightController from "./flash_highlight_controller"

application.register("flash-highlight", FlashHighlightController)

import AdminPartyProfileController from "./admin_party_profile_controller"

application.register("admin-party-profile", AdminPartyProfileController)

import AdminCalendarsController from "./admin_calendars_controller"

application.register("admin-calendars", AdminCalendarsController)

import AdminGlobalSearchController from "./admin_global_search_controller"

application.register("admin-global-search", AdminGlobalSearchController)

import ConfirmController from "./confirm_controller"

application.register("confirm", ConfirmController)

import ToastController from "./toast_controller"

application.register("toast", ToastController)

import BsModalController from "./bs_modal_controller"

application.register("bs-modal", BsModalController)

import ModalLoaderController from "./modal_loader_controller"

application.register("modal-loader", ModalLoaderController)

import ReminderDeleteController from "./reminder_delete_controller.js"

application.register("reminder-delete", ReminderDeleteController)

import TabsController from "./tabs_controller"

application.register("tabs", TabsController)

import InlineSignupController from "./inline_signup_controller.js"

application.register("inline-signup", InlineSignupController)

import InlineLoginController from "./inline_login_controller.js"

application.register("inline-login", InlineLoginController)

import FreshCsrfController from "./fresh_csrf_controller.js"
application.register("fresh-csrf", FreshCsrfController)

import InlineResetPasswordController from "./inline_reset_password_controller.js"

application.register("inline-reset-password", InlineResetPasswordController)

import AddressBookFormController from "./address_book_form_controller.js"

application.register("address-book-form", AddressBookFormController)

import ContactEditController from "./contact_edit_controller.js"

application.register("contact-edit-form", ContactEditController)

import ThankYouController from "./thank_you_controller"

application.register("thank-you", ThankYouController)

import PartyMessagesController from "./party_messages_controller.js"

application.register("party-messages", PartyMessagesController)

import SwalController from "./swal_controller.js"

application.register("swal", SwalController)

import TabSwitchController from "./tab_switch_controller.js"

application.register("tab-switch", TabSwitchController)

import GuestActionsController from "./guest_actions_controller.js"

application.register("guest-actions", GuestActionsController)
import RsvpFormController from "./rsvp_guest_form_controller.js"

application.register("rsvp-guest-form", RsvpFormController)

import CounterController from "./counter_controller.js"

application.register("counter", CounterController)

import RsvpPaymentFormController from "./rsvp_payment_form_controller.js"

application.register("rsvp-payment-form", RsvpPaymentFormController)

import RsvpGiftFormController from "./rsvp_gift_from_controller.js"

application.register("gift-form", RsvpGiftFormController)

import BulkInvitesController from "./bulk_invites_controller.js"

application.register("bulk-invites", BulkInvitesController)

import PayoutChoiceController from "./payout_choice_controller.js"

application.register("payout-choice", PayoutChoiceController)

import ContactPickerController from "./contact_picker_controller.js"

application.register("contact-picker", ContactPickerController)

import ContactsPickerController from "./contact_picker_controller.js"

application.register("contacts-picker", ContactsPickerController)

import ModalDismissController from "./modal_dismiss_controller.js"

application.register("modal-dismiss", ModalDismissController)

import SwalConfirmController from "./swal_confirm_controller.js"

application.register("swal-confirm", SwalConfirmController)

import RsvpValidationController from "./rsvp_validation_controller.js"

application.register("rsvp-validation", RsvpValidationController)

import AutoShowModalController from "./auto_show_modal_controller.js"

application.register("auto-show-modal", AutoShowModalController)

import RsvpLookupController from "./rsvp_lookup_controller.js"

application.register("rsvp-lookup", RsvpLookupController)

import InvitationFiltersController from "./invitation_filters_controller.js"

application.register("invitation-filters", InvitationFiltersController)

import ProgressiveImageController from "./progressive_image_controller.js"

application.register("progressive-image", ProgressiveImageController)

import InvitationEditorController from "./invitation_editor_controller.js"

application.register("invitation-editor", InvitationEditorController)

import TextFormatController from "./text_format_controller.js"

application.register("text-format", TextFormatController)

import EditorToolSwitchController from "./editor_tool_switch_controller.js"

application.register("editor-tool-switch", EditorToolSwitchController)

import PhotoRowToggleController from "./photo_row_toggle_controller.js"

application.register("photo-row-toggle", PhotoRowToggleController)

import StickerPickerController from "./sticker_picker_controller.js"

application.register("sticker-picker", StickerPickerController)

import CountryModalController from "./country_modal_controller.js"

application.register("country-modal", CountryModalController)

import EditorNavController from "./editor_nav_controller.js"

application.register("editor-nav", EditorNavController)

import AdditionalInfoController from "./additional_info_controller.js"

application.register("additional-info", AdditionalInfoController)

import GuestListController from "./guest_list_controller.js"

application.register("guest-list", GuestListController)

import ReviewController from "./review_controller.js"

application.register("review", ReviewController)

import PromoRedeemController from "./promo_redeem_controller.js"

application.register("promo-redeem", PromoRedeemController)

import DraftCardController from "./draft_card_controller.js"

application.register("draft-card", DraftCardController)

import LiveSearchController from "./live_search_controller.js"

application.register("live-search", LiveSearchController)

import ProgressBarController from "./progress_bar_controller.js"

application.register("progress-bar", ProgressBarController)

import SearchFormController from "./search_form_controller.js"

application.register("search-form", SearchFormController)

import ExclusiveRecipientsController from "./exclusive_recipients_controller.js"

application.register("exclusive-recipients", ExclusiveRecipientsController)

import OptionFilterController from "./option_filter_controller"

application.register("option-filter", OptionFilterController)

import ConversionTagsController from "./conversion_tags_controller.js"

application.register("conversion-tags", ConversionTagsController)

import SocialAuthController from "./social_auth_controller.js"
application.register("social-auth", SocialAuthController)

import AuthContinuationCleanupController from "./auth_continuation_cleanup_controller.js"
application.register("auth-continuation-cleanup", AuthContinuationCleanupController)

import CharityPayoutValidationController from "./charity_payout_validation_controller.js"

application.register("charity-payout-validation", CharityPayoutValidationController)

import ThankYouEditorController from "./thank_you_editor_controller"
application.register("thank-you-editor", ThankYouEditorController)

import AiInvitationController from "./ai_invitation_controller"
application.register("ai-invitation", AiInvitationController)

import AiInvitationStatusController from "./ai_invitation_status_controller"
application.register("ai-invitation-status", AiInvitationStatusController)

import InteracPayoutController from "./interac_payout_controller";
application.register("interac-payout", InteracPayoutController)

import SwalAiNotificationController from "./swal_ai_notification_controller"
application.register("swal-ai-notification", SwalAiNotificationController)

import CharityEftPayoutController from "./charity_eft_payout_controller"
application.register("charity-eft-payout", CharityEftPayoutController)

import PartyLinksModalController from "./party_links_modal_controller";
application.register("party-links-modal", PartyLinksModalController);

import CharityPartiesViewController from "./charity_parties_view_controller"
application.register("charity-parties-view", CharityPartiesViewController)

import CharitySidebarController from "./charity_sidebar_controller"
application.register("charity-sidebar", CharitySidebarController)

import UnsubscribeValidationController from "./unsubscribe_validation_controller.js"
application.register("unsubscribe-validation", UnsubscribeValidationController);

import InvitationAnimationController from "./invitation_animation_controller.js"
application.register("invitation-animation", InvitationAnimationController);

import WaitingLottieController from "./waiting_lottie_controller.js"
application.register("waiting-lottie", WaitingLottieController)

import RsvpInvitationSoundController from "./rsvp_invitation_sound_controller"
application.register("rsvp-invitation-sound", RsvpInvitationSoundController)

import DropdownController from "./dropdown_controller";
application.register("dropdown", DropdownController);

import ToggleController from "./toggle_controller";
application.register("toggle", ToggleController);

import CharityDropdownController from "./charity_dropdown_controller";
application.register("charity-dropdown", CharityDropdownController);

import CharityMarketingController from "./charity_marketing_controller";
application.register("charity-marketing", CharityMarketingController);

import HeroShareController from "./hero_share_controller";
application.register("hero-share", HeroShareController);

import AwardEditorController from "./award_editor_controller";
application.register("award-editor", AwardEditorController);

import CharityAnalyticsController from "./charity_analytics_controller";
application.register("charity-analytics", CharityAnalyticsController);

import PartyPlaceController from "./party_place_controller";
application.register("party-place", PartyPlaceController);

import FlashController from "./flash_controller";
application.register("flash", FlashController);

import CommunityDiscardController from "./community_discard_controller";
application.register("community-discard", CommunityDiscardController);

import AdminFaqsController from "./admin_faqs_controller";
application.register("admin-faqs", AdminFaqsController);

import OnboardingUploadController from "./onboarding_upload_controller";
application.register("onboarding-upload", OnboardingUploadController);

import TwModalController from "./tw_modal_controller";
application.register("tw-modal", TwModalController);

import HeroOnboardingController from "./hero_onboarding_controller"
import HeroVideoUploadController from "./hero_video_upload_controller"

application.register("hero-onboarding", HeroOnboardingController)
application.register("hero-video-upload", HeroVideoUploadController)

import SocialMediaKitController from "./social_media_kit_controller";
application.register("social-media-kit", SocialMediaKitController);

import PeriodicContactPromptController from "./periodic_contact_prompt_controller";
application.register("periodic-contact-prompt", PeriodicContactPromptController);

import HostContactPromptController from "./host_contact_prompt_controller";
application.register("host-contact-prompt", HostContactPromptController);

import SectionHighlightController from "./section_highlight_controller";
application.register("section-highlight", SectionHighlightController);

import AutoplayVideoController from "./autoplay_video_controller"
application.register("autoplay-video", AutoplayVideoController)

import CharityApprovalController from "./charity_approval_controller";
application.register("charity-approval", CharityApprovalController);

import CharityVerificationController from "./charity_verification_controller";
application.register("charity-verification", CharityVerificationController);

import CharityReportModalController from "./charity_report_modal_controller";
application.register("charity-report-modal", CharityReportModalController);

import GiftTrashAnimationController from "./gift_trash_animation_controller"
application.register("gift-trash-animation", GiftTrashAnimationController)

import SaveTheDateSwalController from "./save_the_date_swal_controller"
application.register("save-the-date-swal", SaveTheDateSwalController)

import GuestRsvpFormController from "./guest_rsvp_form_controller"
application.register("guest-rsvp-form", GuestRsvpFormController);

import CloudflareVideoUploadController from "./cloudflare_video_upload_controller"
application.register("cloudflare-video-upload", CloudflareVideoUploadController);

import OtpInputController from "./otp_input_controller";
application.register("otp-input", OtpInputController);

import ResendCountdownController from "./resend_countdown_controller";
application.register("resend-countdown", ResendCountdownController);

import RsvpInvitationPrintController from "./rsvp_invitation_print_controller";
application.register("rsvp-invitation-print", RsvpInvitationPrintController);

import ScrollToController from "./scroll_to_controller";
application.register("scroll-to", ScrollToController);

import PartySettingsController from "./party_settings_controller";
application.register("party-settings", PartySettingsController);

import DebbieStrategyCallCalendarController from "./debbie_strategy_call_calendar_controller";
application.register("debbie-strategy-call-calendar", DebbieStrategyCallCalendarController);

import VenueAttendeesController from "./venue_attendees_controller";
application.register("venue-attendees", VenueAttendeesController);

import AutoOpenModalController from "./auto_open_modal_controller";
application.register("auto-open-modal", AutoOpenModalController);

import VenueWaiverChoiceController from "./venue_waiver_choice_controller";
application.register("venue-waiver-choice", VenueWaiverChoiceController);

import ReceiptStatusController from "./receipt_status_controller";
application.register("receipt-status", ReceiptStatusController);

import BulkReceiptStatusController from "./bulk_receipt_status_controller";
application.register("bulk-receipt-status", BulkReceiptStatusController);

import AdminShellController from "./admin_shell_controller";
application.register("admin-shell", AdminShellController);

import AdminChartController from "./admin_chart_controller";
application.register("admin-chart", AdminChartController);

import AdminLiveDashboardController from "./admin_live_dashboard_controller";
application.register("admin-live-dashboard", AdminLiveDashboardController);

import AdminDatepickerController from "./admin_datepicker_controller";
application.register("admin-datepicker", AdminDatepickerController);

import AdminStrategyCallBlockController from "./admin_strategy_call_block_controller";
application.register("admin-strategy-call-block", AdminStrategyCallBlockController);

import AdminAvailabilityController from "./admin_availability_controller";
application.register("admin-availability", AdminAvailabilityController);

import AdminLiveSearchController from "./admin_live_search_controller";
application.register("admin-live-search", AdminLiveSearchController);

import AdminGiftCardsController from "./admin_gift_cards_controller";
application.register("admin-gift-cards", AdminGiftCardsController);

import AdminMarketingFiltersController from "./admin_marketing_filters_controller";
application.register("admin-marketing-filters", AdminMarketingFiltersController);

import AdminMarketingSelectionController from "./admin_marketing_selection_controller";
application.register("admin-marketing-selection", AdminMarketingSelectionController);

import AdminCampaignsController from "./admin_campaigns_controller";
application.register("admin-campaigns", AdminCampaignsController);

import AdminPwaController from "./admin_pwa_controller";
application.register("admin-pwa", AdminPwaController);

import AdminCampaignEventController from "./admin_campaign_event_controller";
application.register("admin-campaign-event", AdminCampaignEventController);

import AdminMarketingClaimEventController from "./admin_marketing_claim_event_controller";
application.register("admin-marketing-claim-event", AdminMarketingClaimEventController);

import AdminMarketingDialogController from "./admin_marketing_dialog_controller";
application.register("admin-marketing-dialog", AdminMarketingDialogController);
import AdminMarketingCopyController from "./admin_marketing_copy_controller";
application.register("admin-marketing-copy", AdminMarketingCopyController);

import AdminMarketingComposerController from "./admin_marketing_composer_controller";
application.register("admin-marketing-composer", AdminMarketingComposerController);

import AdminPremiumPlacementsController from "./admin_premium_placements_controller";
application.register("admin-premium-placements", AdminPremiumPlacementsController);

import AdminPromoCodesController from "./admin_promo_codes_controller";
application.register("admin-promo-codes", AdminPromoCodesController);

import AdminHostVideosController from "./admin_host_videos_controller"
application.register("admin-host-videos", AdminHostVideosController)

import AdminReportsController from "./admin_reports_controller"
application.register("admin-reports", AdminReportsController)

import AdminNotesController from "./admin_notes_controller";
application.register("admin-notes", AdminNotesController);

import AdminMeetingsController from "./admin_meetings_controller";
application.register("admin-meetings", AdminMeetingsController);
